import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4 15H20M4 19H13M4.75 3.85V8.11432C4.75 8.24693 4.80268 8.37411 4.89645 8.46788L8.82502 12.3964C9.02028 12.5917 9.33686 12.5917 9.53212 12.3964L13.3964 8.53212C13.5917 8.33686 13.5917 8.02028 13.3964 7.82502L9.46788 3.89645C9.37411 3.80268 9.24693 3.75 9.11432 3.75H4.85C4.79477 3.75 4.75 3.79477 4.75 3.85Z" />
	</SVG>
);
